'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var loading = 0;
var onload = 1;
var onerror = 2;

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  return function() {
    var Super = _getPrototypeOf(Derived), result;
    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
var ContextLink = /* @__PURE__ */ React__namespace.createContext({
  linkList: {},
  createLink: function createLink() {
  },
  allCreateLink: function allCreateLink() {
  },
  scriptList: {},
  createScript: function createScript() {
  },
  allCreateScript: function allCreateScript() {
  }
});
var ChainLinkProvider = /* @__PURE__ */ function(_React$Component) {
  _inherits(ChainLinkProvider2, _React$Component);
  var _super = _createSuper2(ChainLinkProvider2);
  function ChainLinkProvider2(props) {
    var _this;
    _classCallCheck(this, ChainLinkProvider2);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "createLink", function(href) {
      if (_this.state.linkList[href] !== onload) {
        var linkElement = document.createElement("link");
        linkElement.href = href;
        linkElement.rel = "stylesheet";
        linkElement.dataset.chainLink = "true";
        linkElement.onload = function() {
          _this.setLink(href, onload);
        };
        linkElement.onerror = function() {
          _this.setLink(href, onerror);
        };
        document.head.appendChild(linkElement);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "createScript", function(src) {
      if (_this.state.scriptList[src] !== onload) {
        var scriptElement = document.createElement("script");
        scriptElement.src = src;
        scriptElement.dataset.chainLink = "true";
        scriptElement.onload = function() {
          _this.setScript(src, onload);
        };
        scriptElement.onerror = function() {
          _this.setScript(src, onerror);
        };
        document.body.appendChild(scriptElement);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "allCreateLink", function(hrefs) {
      hrefs.forEach(function(href) {
        _this.createLink(href);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "allCreateScript", function(hrefs) {
      hrefs.forEach(function(href) {
        _this.createScript(href);
      });
    });
    _this.state = {
      linkList: {},
      createLink: _this.createLink,
      allCreateLink: _this.allCreateLink,
      scriptList: {},
      createScript: _this.createScript,
      allCreateScript: _this.allCreateScript
    };
    return _this;
  }
  _createClass(ChainLinkProvider2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var linkElements = document.querySelectorAll("link[data-chain-link]");
      linkElements.forEach(function(linkElement) {
        linkElement.onload = null;
        linkElement.onerror = null;
      });
    }
  }, {
    key: "setLink",
    value: function setLink(href, state) {
      var linkList = this.state.linkList;
      linkList[href] = state;
      this.setState({
        linkList: linkList
      });
    }
  }, {
    key: "setScript",
    value: function setScript(src, state) {
      var scriptList = this.state.scriptList;
      scriptList[src] = state;
      this.setState({
        scriptList: scriptList
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React__namespace.createElement(ContextLink.Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);
  return ChainLinkProvider2;
}(React__namespace.Component);

var returnStatus = function returnStatus2(statuses) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = void 0;
  try {
    for (var _iterator = statuses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var status = _step.value;
      if (status === onerror) {
        return onerror;
      }
      if (!status) {
        return loading;
      }
      if (status === loading) {
        return loading;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return onload;
};
var ChainLink = function ChainLink2(props) {
  var contextLink = React.useContext(ContextLink);
  var hrefs = props.hrefs ? props.hrefs : [];
  var srces = props.srces ? props.srces : [];
  React.useEffect(function() {
    contextLink.linkList = {};
    var linkElements = document.querySelectorAll("link[data-chain-link]");
    linkElements.forEach(function(link) {
      link.remove();
    });
    contextLink.allCreateLink(hrefs);
    contextLink.allCreateScript(srces);
  }, []);
  var statuses_hrefs = hrefs.map(function(href) {
    return contextLink.linkList[href];
  });
  var statuses_srces = srces.map(function(src) {
    return contextLink.scriptList[src];
  });
  var statuses = statuses_hrefs.concat(statuses_srces);
  var status = returnStatus(statuses);
  switch (status) {
    case onerror:
      return props.onerror ? props.onerror() : null;
    case !status:
    case loading:
      return props.loading ? props.loading() : null;
    case onload:
      return /* @__PURE__ */ React__default['default'].createElement(React__default['default'].Fragment, null, props.children);
    default:
      return null;
  }
};

exports.ChainLink = ChainLink;
exports.ChainLinkProvider = ChainLinkProvider;
